import { ChangeEvent, FC } from 'react'

import Input from 'common/components/Input'

type Props = {
  value: string
  onChange: (value: string) => void
  'data-cy': string
}

const SearchInput: FC<Props> = ({ value, onChange, 'data-cy': dataCy }) => {
  return (
    <Input
      type="search"
      value={value}
      placeholder="Search"
      data-cy={dataCy}
      onChange={(event: ChangeEvent<HTMLInputElement>) =>
        onChange(event.target.value)
      }
      clear={() => onChange('')}
      className={`h-10 w-full px-12 py-2 text-sm text-coolGray-800 
        placeholder-sm placeholder-coolGray-800 placeholder-opacity-50 
        border border-blueGray-300 rounded bg-white focus:outline-none 
        focus:text-orange-400 focus:placeholder-orange-400 
        focus:border-orange-400 focus:bg-orange-400 focus:bg-opacity-10`}
    />
  )
}

export default SearchInput
